module.exports = __webpack_public_path__ + "static/business-decisions-8c6143cde1efa9f5587284c0b344dc06.svg";